import { cn } from "@/frontend/lib/utils";

/** Standard dashboard page container: full width to 1920px, 24px gutters. */
export function PageShell({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn("mx-auto w-full max-w-[120rem] px-6", className)}>{children}</div>;
}
